import type { Link } from '@wix/public-schemas'
import type { EmailLinkData } from './linksDataTypes'
import { SAME_TAB_TARGET } from './constants'

const resolveEmailLink = ({
	recipient,
	subject,
	body,
	bcc = undefined,
	cc = undefined,
}: Omit<EmailLinkData, 'type' | 'id'> & { bcc?: string; cc?: string }): string => {
	const queryString = Object.entries({ subject, body, bcc, cc })
		.filter(([, value]) => value)
		.map(([key, value]) => `${key}=${value}`)
		.join('&')

	const query = queryString.length > 0 ? `?${queryString}` : ''
	return `mailto:${recipient}${query}`
}

export const handleEmailLink = (linkData: EmailLinkData): Link => {
	return { href: resolveEmailLink(linkData), target: SAME_TAB_TARGET }
}
